import { render, staticRenderFns } from "./form-template.vue?vue&type=template&id=67854d90"
import script from "./form-template.vue?vue&type=script&lang=js"
export * from "./form-template.vue?vue&type=script&lang=js"
import style0 from "./form-template.vue?vue&type=style&index=0&id=67854d90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports